module.exports = __webpack_public_path__ + "img/PR0830.6e0ec67a.png";